module.exports = __webpack_public_path__ + "img/ic_shared.d593eb1c.svg";